export const enUS_etc = {
   'title.codeChecker': 'UKW Code Checker',
}